import React from "react";
import { Box, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import DriverSchedule from "./DriverSchedule";
import { useAdmin } from "../context/AdminContext";

const MySchedule = () => {
  const { hasAccess } = useAdmin();
  const canViewStaffSchedule = hasAccess("staffSchedule");

  return (
    <>
      {/* {canViewStaffSchedule && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", px: 3, pt: 2 }}>
          <Button
            component={RouterLink}
            to="/staff-schedule"
            variant="outlined"
            sx={{ textTransform: "none", fontWeight: 600 }}
          >
            Admin Staff Schedule
          </Button>
        </Box>
      )} */}
      <DriverSchedule
        defaultScope="staff"
        hideScopeToggle
        myScheduleOnly
        titleOverride="My Schedule"
      />
    </>
  );
};

export default MySchedule;
